module.exports = __webpack_public_path__ + "img/st-tradein.3d8ff0e9.jpg";